<template>
  <div class="container mol-typical-page-container-20 text-center">
    <div class="icon-row">
      <img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">
      <img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">
      <img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">
      <img :src="`${$imagePathBase}nom_icon.svg`" alt="Logo" class="logo-image">
      <img :src="`${$imagePathBase}win_icon.svg`" alt="Logo" class="logo-image">
    </div>
    <div class="page-not-found-text text-my-oscar-list">PAGE<span class="text-oscar">NOT</span>FOUND</div>

    <router-link class="my-oscar-list-link" to="/welcome">
      <span class="text-return-to">RETURN TO</span><br>

      <span class="text-my-oscar-list">
<!--        <img :src="`${$imagePathBase}logo.svg`" alt="Logo" class="logo-image">MY<span class="text-oscar">OSCAR</span>LIST-->
        <ColorThemeImg :src="`${$imagePathBase}logo.svg`" :dark_theme_src="`${$imagePathBase}logo-white.svg`" alt="Logo" class="logo-image"/>MY<span class="text-oscar">OSCAR</span>LIST
      </span>
    </router-link>
  </div>

</template>


<script>

import ColorThemeImg from "@/components/ColorThemeImg.vue";

export default {
  name: "NotFoundPage",
  // eslint-disable-next-line
  components: {ColorThemeImg},
  data() {
    return {
    }
  },

}
</script>


<style scoped>

.icon-row {
  margin: 30px auto 0 auto;
  max-width: 400px;
  width: 75%;
  img {
    margin-bottom: 1em;
    width: 20%;
  }

}

.text-my-oscar-list {

  font-weight: 300;

  .text-oscar {
    font-weight: 600;
    padding-left: 0.05em;
    padding-right: 0.05em;
  }
}
.page-not-found-text {
  font-size: xx-large;
  color: #b49823;
  text-align: center;
}

.my-oscar-list-link {

  background-color: var(--bs-tertiary-bg);
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  padding: 10px;

  &:hover {
    border-width: 2px;
    border-color: #b49823;
    padding: 9px;
  }


  width: fit-content;

  margin-top: 100px;

  margin-left: auto;
  margin-right: auto;

  display: block;
  color: inherit;
  text-decoration: inherit;


  .text-return-to {
    font-size: medium;
  }

  .text-my-oscar-list {
    font-size: x-large;

    .logo-image {
      margin-top: -0.15em;
      margin-right: 0.1em;
      width: 1.3em;
    }
  }
}

:deep(.text-my-oscar-list .logo-image) {
  margin-top: -0.15em;
  margin-right: 0.1em;
  width: 1.3em;
}


</style>